import { EmployeeCenterDetailsType } from 'src/components/Employees/types';

export class EmployeesManager {
    static employeeCenterSorter = (centers?: EmployeeCenterDetailsType[]): EmployeeCenterDetailsType[] => {
        if (!centers) {
            return [];
        }
        return centers.sort((a: EmployeeCenterDetailsType, b: EmployeeCenterDetailsType) => {
            if (a.shortName == b.shortName) {
                if ((a.employeeId || 0) > (b.employeeId || 0)) {
                    return 1;
                }
                if ((a.employeeId || 0) < (b.employeeId || 0)) {
                    return -1;
                }
            } else {
                if (a.shortName > b.shortName) {
                    return 1;
                }
                if (a.shortName < b.shortName) {
                    return -1;
                }
            }
            return 0;
        });
    };
}
